import * as React from 'react';
import '../../../rc-motion/es/CSSMotion.js';
import '../../../rc-motion/es/CSSMotionList.js';
import MotionProvider from '../../../rc-motion/es/context.js';
import '../../../@ant-design/cssinjs/es/extractStyle.js';
import '../../../@ant-design/cssinjs/es/hooks/useCacheToken.js';
import '../../../rc-util/es/Dom/dynamicCSS.js';
import '../../../@ant-design/cssinjs/es/StyleContext.js';
import '../../../@ant-design/cssinjs/es/util/index.js';
import '../../../@ant-design/cssinjs/es/hooks/useCompatibleInsertionEffect.js';
import '../../../@ant-design/cssinjs/es/hooks/useEffectCleanupRegister.js';
import '../../../@ant-design/cssinjs/es/hooks/useHMR.js';
import '../../../@emotion/unitless/dist/unitless.cjs.js';
import '../../../stylis/dist/umd/stylis.js';
import '../../../rc-util/es/warning.js';
import '../../../@ant-design/cssinjs/es/theme/createTheme.js';
import '../../../@ant-design/cssinjs/es/theme/ThemeCache.js';
import '../../../@ant-design/cssinjs/es/transformers/legacyLogicalProperties.js';
import useToken from '../theme/useToken.js';
function MotionWrapper(props) {
  const {
    children
  } = props;
  const [, token] = useToken();
  const {
    motion
  } = token;
  const needWrapMotionProviderRef = React.useRef(false);
  needWrapMotionProviderRef.current = needWrapMotionProviderRef.current || motion === false;
  if (needWrapMotionProviderRef.current) {
    return /*#__PURE__*/React.createElement(MotionProvider, {
      motion: motion
    }, children);
  }
  return children;
}
export { MotionWrapper as default };
//# sourceMappingURL=MotionWrapper.js.map
